var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderActivation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.412 5.78219C16.412 6.9258 16.0729 8.04373 15.4376 8.99461C14.8022 9.94549 13.8992 10.6866 12.8426 11.1242C11.786 11.5619 10.6234 11.6764 9.5018 11.4533C8.38017 11.2302 7.34988 10.6795 6.54122 9.87082C5.73257 9.06217 5.18187 8.03188 4.95876 6.91024C4.73565 5.78861 4.85016 4.626 5.2878 3.56944C5.72544 2.51289 6.46656 1.60983 7.41744 0.974475C8.36832 0.33912 9.48624 0 10.6299 0C11.3892 0 12.1411 0.149561 12.8426 0.440143C13.5441 0.730726 14.1816 1.15664 14.7185 1.69357C15.2554 2.23049 15.6813 2.86792 15.9719 3.56944C16.2625 4.27097 16.412 5.02287 16.412 5.78219Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.2851H21.2542V18.3098C21.223 16.4193 20.453 14.6161 19.109 13.2863C18.174 12.3421 17.0583 11.5959 15.8287 11.0923C14.599 10.5886 13.2805 10.3377 11.9518 10.3547H9.30124C7.94293 10.3362 6.59541 10.5981 5.34299 11.1243C4.09057 11.6504 2.9602 12.4293 2.02261 13.4123C0.751259 14.7289 0.0281839 16.4798 0 18.3098",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48193 17.0054L9.31752 19.841L14.4533 14.8013",
    fill: "#888888"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48193 17.0054L9.31752 19.841L14.4533 14.8013",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderActivation);
export default __webpack_public_path__ + "static/media/headerActivation.7cb03ed08fbcb780f0e22033498378fe.svg";
export { ForwardRef as ReactComponent };